import axios from '../axios'
// 获取权限菜单
export const findNavMenuTree = data => {
  return axios({
    url: '/auth/sysAuthorityMenu/agency/self_menu/3/' + data.agencyId,
    method: 'get',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/modules/menu.js